// Helper compartido para el sidebar oscuro (desktop y responsive)
import { Flex, Link, Text, Tooltip } from "@chakra-ui/react";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

export const SidebarBrand = ({ collapsed = false }) => (
  <Flex align="center" justify={collapsed ? "center" : "flex-start"} gap="11px" px={collapsed ? "0" : "8px"} pb="22px" pt="4px">
    <Flex
      w="38px"
      h="38px"
      borderRadius="12px"
      flex="0 0 auto"
      bgGradient="linear(150deg, #F2683C, #E84A1E)"
      boxShadow="0 6px 16px -4px rgba(232,74,30,.7)"
    />
    {!collapsed && (
      <Text fontWeight="800" fontSize="21px" letterSpacing="-0.02em" color="#fff">
        Dato
        <Text as="span" color="#FF7A4D">
          fy
        </Text>
      </Text>
    )}
  </Flex>
);

export const SidebarLinks = ({ routes, onNavigate, collapsed = false }) => {
  const location = useLocation();

  return (
    <Flex direction="column" gap="2px">
      {routes.map((prop) => {
        if (prop.redirect) {
          return null;
        }

        if (prop.category) {
          return (
            <React.Fragment key={prop.name}>
              {collapsed ? (
                <Flex justify="center" py="10px">
                  <Flex w="20px" borderTop="1px solid" borderColor="#3A332C" />
                </Flex>
              ) : (
                <Text
                  fontSize="11px"
                  fontWeight="700"
                  letterSpacing="0.09em"
                  color="#7C7068"
                  textTransform="uppercase"
                  px="12px"
                  pt="16px"
                  pb="8px"
                >
                  {prop.name}
                </Text>
              )}
              <SidebarLinks routes={prop.views} onNavigate={onNavigate} collapsed={collapsed} />
            </React.Fragment>
          );
        }

        const fullPath = prop.layout + prop.path;
        const isActive = location.pathname === fullPath;

        const link = (
          <Link
            as={NavLink}
            to={fullPath}
            onClick={onNavigate}
            display="flex"
            alignItems="center"
            justifyContent={collapsed ? "center" : "flex-start"}
            gap={collapsed ? "0" : "13px"}
            px={collapsed ? "0" : "13px"}
            py="12px"
            w={collapsed ? "44px" : "auto"}
            h={collapsed ? "44px" : "auto"}
            mx={collapsed ? "auto" : "0"}
            borderRadius="13px"
            fontWeight="600"
            fontSize="14.5px"
            color={isActive ? "#fff" : "#B8ABA1"}
            bg={isActive ? "coral.500" : "transparent"}
            boxShadow={isActive ? "0 10px 24px -10px rgba(239,90,42,.85)" : "none"}
            transition="0.14s"
            _hover={{
              bg: isActive ? "coral.500" : "rgba(255,255,255,.07)",
              color: "#fff",
              textDecoration: "none",
            }}
          >
            {React.isValidElement(prop.icon)
              ? React.cloneElement(prop.icon, { boxSize: "20px" })
              : null}
            {!collapsed && <Text>{prop.name}</Text>}
          </Link>
        );

        // Riel de íconos: sin texto visible, así que el nombre se ofrece
        // como tooltip al pasar el mouse — sin esto no habría forma de
        // saber a qué sección lleva cada ícono en este modo.
        return (
          <React.Fragment key={prop.name}>
            {collapsed ? (
              <Tooltip label={prop.name} placement="right" hasArrow>{link}</Tooltip>
            ) : link}
          </React.Fragment>
        );
      })}
    </Flex>
  );
};
